import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import FormInput from '../../../../../../components/customElements/FormInput'
import CustomAccordion from '../../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import DealerFormStore from '../../../../../../stores/DealerFormStore'
import { gState } from '../../../../../../utils/controllers/GlobalStateController'
import { getStyles } from '../../../../../../utils/utils/commonUtils'
import { getComp } from '../../../../../../utils/utils/DI'
import requestsManagementStyles from '../../../../styles/requestsManagementStyles'
import DealerCard from './DealerCard'

function DealerSelect({ store, massAssign, currentServiceData }) {
  const intl = gState['intl']
  const classes = getStyles(requestsManagementStyles)
  const dealersStore = getComp('DealersStore')
  const [dealerFilterStore] = useState(() => new DealerFormStore())

  useEffect(() => {
    store.newDealer = null
  }, [])
  const currentDealerId = null

  const selectDealer = (subjectId) => {
    store.newDealer = subjectId
  }
  const searchTabs = useMemo(
    () => [
      { propName: 'displayName', name: intl.formatMessage({ id: 'Имя' }) },
    ],
    [],
  )
  const [searchTab, setSearchTab] = useState(searchTabs[0].propName)
  const { subjectId, displayName } = dealerFilterStore.data

  useEffect(() => {
    if (
      (store.ordersStore?.currentServiceData?.assignedDealerId ||
        currentServiceData?.assignedDealerId) &&
      !massAssign
    ) {
      store.newDealer =
        currentServiceData?.assignedDealerId ||
        store.ordersStore?.currentServiceData?.assignedDealerId
    }
  }, [
    currentServiceData?.assignedDealerId,
    store.ordersStore?.currentServiceData?.assignedDealerId,
  ])

  const filteredDealers = () => {
    // фильтрация дилеров по текущему дилеру заявки

    const collectionWithoutCurrentDealer = dealersStore.collection.filter(
      (el) => {
        return el.subjectId !== currentDealerId
      },
    )

    if (searchTab === 'subjectId' && subjectId) {
      return collectionWithoutCurrentDealer.filter((el) => {
        return el.subjectId.includes(subjectId)
      })
    } else if (searchTab === 'displayName' && displayName) {
      return collectionWithoutCurrentDealer.filter((el) => {
        return el.displayName.toLowerCase().includes(displayName.toLowerCase())
      })
    } else {
      return collectionWithoutCurrentDealer
    }
  }

  return (
    <React.Fragment>
      <Box
        name={'dealer-search'}
        sx={{
          marginTop: store.data?.status === 123 || !store.data ? '20px' : '0px',
        }}
      ></Box>
      <Box mx={-2}>
        <CustomAccordion
          defaultOpenState={true}
          summary={intl.formatMessage({ id: 'Назначить на дилера' })}
        >
          {searchTabs.map((el, i) => (
            <Box
              sx={{
                display: searchTab !== el.propName ? 'none' : 'block',
                marginY: '10px',
              }}
              key={i}
            >
              <FormInput
                fullWidth
                api={dealerFilterStore}
                propName={el.propName}
                label={el.name}
              />
            </Box>
          ))}
          <Stack
            name={'dealers-list'}
            spacing={1}
            className={css(classes.dealersScrollContainer)}
            style={{ minHeight: store.newDealer ? '36vh' : '45vh' }}
          >
            <>
              {filteredDealers().map((dealerItem) => (
                <DealerCard
                  key={dealerItem.subjectId}
                  dealer={dealerItem}
                  selected={store.newDealer === dealerItem.subjectId}
                  onSelect={() => selectDealer(dealerItem.subjectId)}
                />
              ))}
            </>
          </Stack>
        </CustomAccordion>
      </Box>
    </React.Fragment>
  )
}

export default observer(DealerSelect)
